'use client';

import { ThemeVariables } from '@/themes/mpanels/variables';
import { GlobalStyles, Theme } from '@mui/material';
import { ReactNode, useEffect } from 'react';
import { generateGlobalStyles } from '@/utils/styles/generateGlobalStyles';
import { useThemeStore } from '@/store/themeStore';
interface ThemeRegistryProps {
    theme: Theme;
    variables: ThemeVariables;
    children: ReactNode;
}

export const ThemeRegistry = ({ theme, variables, children }: ThemeRegistryProps) => {
    const { setTheme, setVariables } = useThemeStore();

    useEffect(() => {
        setTheme(theme);
        setVariables(variables);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <GlobalStyles styles={generateGlobalStyles({ variables })} />
            {children}
        </>
    );
};
